<script setup lang="ts">
const { t } = useI18n()

const { userId } = defineProps<{
	userId: string
}>()

const page = ref(1)
const per_page = ref(10)
const issueOrders = ref<any>(null)
const issueOrdersColumns = computed(() => [
	{ label: t('data'), key: 'created_at', sortable: true },
	{ label: t('type'), key: 'slug', sortable: false },
	{ label: t('status_label'), key: 'status', sortable: false },
	{ label: t('amount'), key: 'price_usdt', sortable: true },
	{ label: t('card_number'), key: 'ax_verify_activation_response.decrypted.cardNo', sortable: false },
	{ label: t('fee'), key: 'fees_processing_result', sortable: false },
])

const fetchIssueOrders = async () => {
	const api = useApi()
	if (!userId) return

	const requestBody: any = {
		filter: { user_id: { '$oid': userId } },
		skip: (page.value - 1) * per_page.value,
		limit: per_page.value,
		sort: { created_at: -1 },
	}
	issueOrders.value = await api.post('/api/cs_issue_orders/find', requestBody)
	return issueOrders.value
}

onMounted(async () => {
	if (!issueOrders.value) {
		await fetchIssueOrders()
	}
})

watch([page, per_page], () => {
	fetchIssueOrders()
})
</script>

<template>
	<div>
		<ResponsiveTable
			:rows="issueOrders?.items"
			:columns="issueOrdersColumns"
		>
			<template #created_at-data="{ row }">
				<DateColumn :row="row" />
			</template>
			<template #slug-data="{ row }">
				<SlugTypeColumn :row="row" :slug-type-id="row.ax_card_issue_payload?.bankcardId ?? row.hp_card_issue_payload?.product_id" />
			</template>
			<template #status-data="{ row }">
				<CardIssueStatusColumn :row="row" />
			</template>
			<template #price_usdt-data="{ row }">
				<div class="space-y-2">
					<div class="flex items-center space-x-2">
						<UIcon name="i-cryptocurrency-usdt" class="w-5 h-5 text-green-600"/>
						<div class="text-zinc-800 dark:text-zinc-300 font-mono text-lg">
							{{ row.price_usdt?.toLocaleString('ru-RU', {maximumFractionDigits :2}) || 0 }}
						</div>
					</div>
				</div>
			</template>
			<template #fees_processing_result-data="{ row }">
				<CardIssueFeeColumn :row="row" />
			</template>
			<template #ax_verify_activation_response.decrypted.cardNo-data="{ row }">
				<div class="text-zinc-800 dark:text-zinc-300" v-if="row.ax_verify_activation_response?.decrypted?.cardNo">
					<UBadge
						:color="'gray'"
						:label="`**** ${row.ax_verify_activation_response?.decrypted?.cardNo}`"
						variant="solid"
					/>
					<div>
						{{ $t('card-id') }} {{ row.ax_verify_activation_response?.decrypted?.bankCardId ?? row.hp_card_id }}
					</div>
				</div>
			</template>
		</ResponsiveTable>
		<div class="flex justify-end mt-4">
			<UPagination
				v-model="page"
				:page-count="per_page"
				:total="issueOrders?.meta?.filter_items_count || 0"
			/>
		</div>
	</div>
</template>
